let scheduled = false;

function checkPosition() {
  const body = document.body;
  const blocks = body.querySelectorAll('.background-switch');
  const triggerPoint = window.innerHeight / 2;
  let lastBlock = null;
  let hasActiveBlock = false;

  blocks.forEach(function(block) {
    const blockTop = block.getBoundingClientRect().top;

    if (blockTop <= triggerPoint) {
      lastBlock = block;
      hasActiveBlock = true;
    }
  });

  let prev = body.classList.contains('default-bg-dark');
  let next = prev;

  for (var i = 0; i < blocks.length; i++) {
    if (blocks[i] !== lastBlock) {
      prev = !prev;
    } else {
      next = !prev;
      break;
    }
  }

  if(next){
    body.classList.add('dark');
  }else{
    body.classList.remove('dark');
  }

  /*if((next && !body.classList.contains('dark')) || (!next && body.classList.contains('dark'))){
    document.startViewTransition(() => {
      if(next){
        body.classList.add('dark');
      }else{
        body.classList.remove('dark');
      }
    });
  }*/
}

function onScrollCheck() {
  if (!scheduled) {
    scheduled = true;
    requestAnimationFrame(function() {
      checkPosition();
      scheduled = false;
    });
  }
}

window.addEventListener('scroll', onScrollCheck);
window.addEventListener('resize', onScrollCheck);
document.addEventListener('DOMContentLoaded', checkPosition);
